import { Match, Show, Switch } from 'solid-js'
import AIFansLoading from '../../AIFansLoading'

interface Props {
  onSubscribe: () => void
  subscribing: boolean
}

const SubscribeButton = (props: Props) => {
  return (
    <button
      class="mt-3 w-full rounded-lg border border-white bg-gradient-to-r from-[#B14DFF] to-[#4A72FF] px-6 py-4 font-clash text-xl font-semibold md:mt-7 md:px-14 md:py-8 md:text-3xl md:text-[28px]"
      onClick={props.onSubscribe}
    >
      <Show
        when={!props.subscribing}
        fallback={
          <div class="flex items-center justify-center">
            <AIFansLoading show={true} plain={true} />
          </div>
        }
      >
        Subscribe Now!
      </Show>
    </button>
  )
}

export default SubscribeButton
